// This file is importing the Stimulus controllers
// That are only used on the landing page

import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

const application = Application.start()
const context = require.context('../landing/controllers', true, /\.js$/)
application.load(definitionsFromContext(context))
